export const { REACT_APP_SUPABASE_URL } = process.env;
export const { REACT_APP_SUPABASE_KEY } = process.env;
